<template>
    <div class="login background-white">
        <div class="min container vertical" :style="{ 'left': mobile ? '-14%' : '' }">
            <div class="inline-block">
                <img class="left-img" src="https://ai.lvwa18.com/img/administration/left-img.png">
            </div>
            <div class="inline-block vertical-align" style="margin-left: 141px;">
                <div>
                    <p class="hello">hello!</p>
                    <p class="cooperation">欢迎登录<span style="color: #2b8bec;">律蛙产品流量合作-管理后台</span> </p>
                </div>
                <div>
                    <div class="input-Administration user1" :class="u==false ? 'typeselect' : 'typeselect1'">
                        <!---->
                        <img class="user" id="img_id" src="https://ai.lvwa18.com/img/administration/user.png">
                        <input  v-model="username" class="input-content" type="text" placeholder="请输用户名" id="txtUserName" autocomplete="on" @focus="changeActive($event)" @blur.prevent="removeActive($event)">
                    </div>
                    <div class="input-Administration password1" :class="m==false ? 'typeselect' : 'typeselect1'">
                        <img class="user" id="lock" src="https://ai.lvwa18.com/img/administration/password.png">
                        <input v-model="password" class="input-content" type="password" placeholder="请输密码" id="txtPassword" @focus="changeActive1($event)" @blur.prevent="removeActive1($event)">
                    </div>
                    <div class="inline-block" style="margin-left: 25px;margin-top: 22px;">
                        <a href="javascript:;">

                            <label>
                                <input v-model="checked" class="remember" checked="checked" type="checkbox" id="chkRememberPwd" @click="remember =!remember"><p class="inline-block remember-x">记住密码</p>
                            </label>
                        </a>
                    </div>
                    <a href="javascript:;" @click="login()"><div class="signin">登 录</div></a>



                </div>
            </div>
        </div>
        <div class="bottom-png min center">
            <!--<p class="inline-block copyright">Copyright © 2017 律蛙智能 版权所有（http://www.lvwa18.com）All Right.</p>-->
        </div>
    </div>
</template>

<script>
    export default {
        name: "login",
        data () {
            return {
               u : false,
               m : false,
               // remember : true,
            //
                username: "",
                password: "",
                checked: true,
                mobile : false,
            }
        },
        methods:{
            // 鼠标移入加入class
            changeActive($event){
                this.u = true
            },
            removeActive($event){
                this.u = false
            },changeActive1($event){
                this.m = true
            },
            removeActive1($event){
                this.m = false
            },
        //
            login() {
                var vm = this
                var params = new URLSearchParams();
                params.append('username', this.username);
                params.append('password', this.password);

                vm.send({
                    server : 'ai',
                    // url : '/API/Manage/Login',
                    headers:{'Content-Type':'application/json'},
                    url : '/Login',
                    data:{userName:vm.username,  passWord: vm.password},
                    success: function (response) {
                        console.log(response.status)
                        if (response.msg == '登录失败') {
                            console.log("ret: " + response.data.ret);
                            alert("用户名或密码错误！")
                        } else {
                            var remeberFlag;
                            //判断复选框是否被勾选
                            if (vm.checked == true) {
                                // console.log("checked == true");
                                remeberFlag = "true";
                            }else {
                                remeberFlag = "false";
                            }
                            //调用配置cookie方法,传入账号名，密码，和保存天数3个参数
                            vm.setCookie(vm.username, vm.password, 7, remeberFlag);
                            vm.$router.push({path:'/newlyAdded'});
                            console.log("username: " + response.data.data.user.username);
                        }
                    }
                })
            },
            //设置cookie
            setCookie(c_name, c_pwd, exdays, remeberFlag) {
                var exdate = new Date(); //获取时间
                exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
                //字符串拼接cookie
                window.document.cookie = "userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
                window.document.cookie = "userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
                window.document.cookie = "remeberFlag" + "=" + remeberFlag + ";path=/;expires=" + exdate.toGMTString();
            },

            //读取cookie
            getCookie: function() {
                if (document.cookie.length > 0) {
                    var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
                    for (var i = 0; i < arr.length; i++) {
                        var arr2 = arr[i].split('='); //再次切割
                        //判断查找相对应的值
                        if (arr2[0] == 'userName') {
                            this.username = arr2[1]; //保存到保存数据的地方
                        } else if (arr2[0] == 'userPwd') {
                            this.password = arr2[1];
                        }
                    }
                }
            },
        //    判断pc
            //App.vue
            _isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                return flag;
            }

        },
        mounted () {
            this.getCookie()
            if (this._isMobile()) {
                this.mobile = true
            } else {
                this.mobile = false
            }
        }
    }
</script>

<style scoped>

    .container{width: 1200px;margin: auto auto;}

    .min{min-width: 1200px;}
    .background-white{background-color: white;position: fixed;height: 100%;width: 100%}
    .vertical{height: 450px;position: absolute;width: 1044px;left: 50%;margin-left: -522px;top:50%;margin-top: -225px;}
    .left-img{width: 443px;height: 446px;}
    .hello{font-size: 30px;color: #cccccc;}
    .cooperation{font-size: 28px;color: #cccccc;}
    .input-content{background:none;outline:none;border:0px;vertical-align: top;margin-top: 5px;color: #999999;height: 45px;width: 350px;}
    .input-Administration{width: 460px;height: 52px;background-color: #fafafa;border-radius:26px;margin-top: 40px;}
    .user{width: 17px;height: 20px;margin-left: 31px;margin-right: 23px;margin-top: 16px;}
    .remember{width:15px;height:15px;border: 1px solid #4a83f6;font-size: 18px;line-height: 16px;text-align: center;color: #4a83f6;}
    .remember-x{color: #4a83f6;vertical-align: top;margin-top: 1px;line-height: 16px;margin-left: 10px;}
    .signin{background-color: #519eec;color: white;font-size: 14px;border-radius: 26px;width: 460px;height: 52px;line-height: 52px;text-align: center;margin-top: 35px;}


    /*管理*/

    .lvwa_texe div{width: 33%;}
    .layui-input{border: 0;background-color: rgb(244,245,249);height: 30px;}
    .layui-input,textarea,select,a:focus {outline: none;}
    .jump_page,textarea,select,a:focus {outline: none;}

    .lvwa_texe1 div{width:22%;white-space:nowrap;overflow:hidden}
    .bottom-png {
        background: url(https://ai.lvwa18.com/img/administration/bottom-png.png) no-repeat;
        width: 100%;
        height: 281px;
        background-size: 100% 100%;
        position: absolute;
        bottom: 0;
        z-index: -1;
    }
    .copyright {
        font-size: 14px;
        color: #519eec;
        margin-top: 232px;
    }
    .typeselect{border: 0px; color: rgb(151, 196, 243); background-color: rgb(250, 250, 250);}
    .typeselect1{border: 1px solid rgb(137,188,241);color: rgb(151, 196, 243);background-color: white;}
</style>
